import * as Types from '../../../api';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GroupNumberIdQueryVariables = Types.Exact<{
  id: Types.Scalars['Int']['input'];
}>;


export type GroupNumberIdQuery = { __typename?: 'Query', groups?: { __typename?: 'GroupList', items: Array<{ __typename?: 'Group', numberId: number } | null> } | null };

export type LocationIdQueryVariables = Types.Exact<{
  name: Types.Scalars['String']['input'];
  domainId: Types.Scalars['Int']['input'];
}>;


export type LocationIdQuery = { __typename?: 'Query', locations?: { __typename?: 'LocationList', items: Array<{ __typename?: 'Location', id: number } | null> } | null };

export type ExtensionProfileIdsQueryVariables = Types.Exact<{
  extensionId: Types.Scalars['Int']['input'];
}>;


export type ExtensionProfileIdsQuery = { __typename?: 'Query', userProfiles?: Array<{ __typename?: 'UserProfile', id: number } | null> | null };

export type IvrDataQueryVariables = Types.Exact<{
  ivrId: Types.Scalars['Int']['input'];
}>;


export type IvrDataQuery = { __typename?: 'Query', ivrs?: { __typename?: 'IvrList', items: Array<{ __typename?: 'Ivr', numberId: number, profiles: Array<{ __typename?: 'IvrProfile', id: number, actions: Array<{ __typename?: 'IvrAction', id: number, button: number }> }> } | null> } | null };

export type SaveExtensionProfileRuleMutationVariables = Types.Exact<{
  data: Types.UserProfileRuleData;
}>;


export type SaveExtensionProfileRuleMutation = { __typename?: 'Mutation', saveUserProfileRule?: { __typename?: 'SaveResult', id?: number | null, errors?: Array<{ __typename?: 'Error', location: Array<string>, type: string, context?: string | null }> | null } | null };

export type DomainImportDeviceVariantListQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type DomainImportDeviceVariantListQuery = { __typename?: 'Query', deviceVariants?: { __typename?: 'DeviceVariantList', items: Array<{ __typename?: 'DeviceVariant', id: number, name: string, domain?: { __typename?: 'Domain', id: number } | null } | null> } | null };

export type AddDomainAdminsMutationVariables = Types.Exact<{
  domainId: Types.Scalars['Int']['input'];
  domainAdmins: Array<Types.DomainAdminInput>;
}>;


export type AddDomainAdminsMutation = { __typename?: 'Mutation', addDomainAdmins: { __typename?: 'MutationResult', errors?: Array<{ __typename?: 'Error', location: Array<string>, type: string, context?: string | null }> | null } };

export type SystemDeviceTypeSetsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type SystemDeviceTypeSetsQuery = { __typename?: 'Query', deviceTypeSets: Array<{ __typename?: 'DeviceTypeSet', name: string, devices: Array<string> }> };


export const GroupNumberIdDocument = gql`
    query GroupNumberId($id: Int!) {
  groups(id: $id) {
    items {
      numberId
    }
  }
}
    `;

/**
 * __useGroupNumberIdQuery__
 *
 * To run a query within a React component, call `useGroupNumberIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGroupNumberIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGroupNumberIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGroupNumberIdQuery(baseOptions: Apollo.QueryHookOptions<GroupNumberIdQuery, GroupNumberIdQueryVariables> & ({ variables: GroupNumberIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GroupNumberIdQuery, GroupNumberIdQueryVariables>(GroupNumberIdDocument, options);
      }
export function useGroupNumberIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GroupNumberIdQuery, GroupNumberIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GroupNumberIdQuery, GroupNumberIdQueryVariables>(GroupNumberIdDocument, options);
        }
export function useGroupNumberIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GroupNumberIdQuery, GroupNumberIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GroupNumberIdQuery, GroupNumberIdQueryVariables>(GroupNumberIdDocument, options);
        }
export type GroupNumberIdQueryHookResult = ReturnType<typeof useGroupNumberIdQuery>;
export type GroupNumberIdLazyQueryHookResult = ReturnType<typeof useGroupNumberIdLazyQuery>;
export type GroupNumberIdSuspenseQueryHookResult = ReturnType<typeof useGroupNumberIdSuspenseQuery>;
export type GroupNumberIdQueryResult = Apollo.QueryResult<GroupNumberIdQuery, GroupNumberIdQueryVariables>;
export const LocationIdDocument = gql`
    query LocationId($name: String!, $domainId: Int!) {
  locations(name: $name, domainId: $domainId) {
    items {
      id
    }
  }
}
    `;

/**
 * __useLocationIdQuery__
 *
 * To run a query within a React component, call `useLocationIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useLocationIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLocationIdQuery({
 *   variables: {
 *      name: // value for 'name'
 *      domainId: // value for 'domainId'
 *   },
 * });
 */
export function useLocationIdQuery(baseOptions: Apollo.QueryHookOptions<LocationIdQuery, LocationIdQueryVariables> & ({ variables: LocationIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LocationIdQuery, LocationIdQueryVariables>(LocationIdDocument, options);
      }
export function useLocationIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LocationIdQuery, LocationIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LocationIdQuery, LocationIdQueryVariables>(LocationIdDocument, options);
        }
export function useLocationIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LocationIdQuery, LocationIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LocationIdQuery, LocationIdQueryVariables>(LocationIdDocument, options);
        }
export type LocationIdQueryHookResult = ReturnType<typeof useLocationIdQuery>;
export type LocationIdLazyQueryHookResult = ReturnType<typeof useLocationIdLazyQuery>;
export type LocationIdSuspenseQueryHookResult = ReturnType<typeof useLocationIdSuspenseQuery>;
export type LocationIdQueryResult = Apollo.QueryResult<LocationIdQuery, LocationIdQueryVariables>;
export const ExtensionProfileIdsDocument = gql`
    query ExtensionProfileIds($extensionId: Int!) {
  userProfiles(extensionId: $extensionId) {
    id
  }
}
    `;

/**
 * __useExtensionProfileIdsQuery__
 *
 * To run a query within a React component, call `useExtensionProfileIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useExtensionProfileIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExtensionProfileIdsQuery({
 *   variables: {
 *      extensionId: // value for 'extensionId'
 *   },
 * });
 */
export function useExtensionProfileIdsQuery(baseOptions: Apollo.QueryHookOptions<ExtensionProfileIdsQuery, ExtensionProfileIdsQueryVariables> & ({ variables: ExtensionProfileIdsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExtensionProfileIdsQuery, ExtensionProfileIdsQueryVariables>(ExtensionProfileIdsDocument, options);
      }
export function useExtensionProfileIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExtensionProfileIdsQuery, ExtensionProfileIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExtensionProfileIdsQuery, ExtensionProfileIdsQueryVariables>(ExtensionProfileIdsDocument, options);
        }
export function useExtensionProfileIdsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ExtensionProfileIdsQuery, ExtensionProfileIdsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ExtensionProfileIdsQuery, ExtensionProfileIdsQueryVariables>(ExtensionProfileIdsDocument, options);
        }
export type ExtensionProfileIdsQueryHookResult = ReturnType<typeof useExtensionProfileIdsQuery>;
export type ExtensionProfileIdsLazyQueryHookResult = ReturnType<typeof useExtensionProfileIdsLazyQuery>;
export type ExtensionProfileIdsSuspenseQueryHookResult = ReturnType<typeof useExtensionProfileIdsSuspenseQuery>;
export type ExtensionProfileIdsQueryResult = Apollo.QueryResult<ExtensionProfileIdsQuery, ExtensionProfileIdsQueryVariables>;
export const IvrDataDocument = gql`
    query IvrData($ivrId: Int!) {
  ivrs(id: $ivrId) {
    items {
      numberId
      profiles {
        id
        actions {
          id
          button
        }
      }
    }
  }
}
    `;

/**
 * __useIvrDataQuery__
 *
 * To run a query within a React component, call `useIvrDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useIvrDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIvrDataQuery({
 *   variables: {
 *      ivrId: // value for 'ivrId'
 *   },
 * });
 */
export function useIvrDataQuery(baseOptions: Apollo.QueryHookOptions<IvrDataQuery, IvrDataQueryVariables> & ({ variables: IvrDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IvrDataQuery, IvrDataQueryVariables>(IvrDataDocument, options);
      }
export function useIvrDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IvrDataQuery, IvrDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IvrDataQuery, IvrDataQueryVariables>(IvrDataDocument, options);
        }
export function useIvrDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<IvrDataQuery, IvrDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<IvrDataQuery, IvrDataQueryVariables>(IvrDataDocument, options);
        }
export type IvrDataQueryHookResult = ReturnType<typeof useIvrDataQuery>;
export type IvrDataLazyQueryHookResult = ReturnType<typeof useIvrDataLazyQuery>;
export type IvrDataSuspenseQueryHookResult = ReturnType<typeof useIvrDataSuspenseQuery>;
export type IvrDataQueryResult = Apollo.QueryResult<IvrDataQuery, IvrDataQueryVariables>;
export const SaveExtensionProfileRuleDocument = gql`
    mutation SaveExtensionProfileRule($data: UserProfileRuleData!) {
  saveUserProfileRule(data: $data) {
    id
    errors {
      location
      type
      context
    }
  }
}
    `;
export type SaveExtensionProfileRuleMutationFn = Apollo.MutationFunction<SaveExtensionProfileRuleMutation, SaveExtensionProfileRuleMutationVariables>;

/**
 * __useSaveExtensionProfileRuleMutation__
 *
 * To run a mutation, you first call `useSaveExtensionProfileRuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveExtensionProfileRuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveExtensionProfileRuleMutation, { data, loading, error }] = useSaveExtensionProfileRuleMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useSaveExtensionProfileRuleMutation(baseOptions?: Apollo.MutationHookOptions<SaveExtensionProfileRuleMutation, SaveExtensionProfileRuleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveExtensionProfileRuleMutation, SaveExtensionProfileRuleMutationVariables>(SaveExtensionProfileRuleDocument, options);
      }
export type SaveExtensionProfileRuleMutationHookResult = ReturnType<typeof useSaveExtensionProfileRuleMutation>;
export type SaveExtensionProfileRuleMutationResult = Apollo.MutationResult<SaveExtensionProfileRuleMutation>;
export type SaveExtensionProfileRuleMutationOptions = Apollo.BaseMutationOptions<SaveExtensionProfileRuleMutation, SaveExtensionProfileRuleMutationVariables>;
export const DomainImportDeviceVariantListDocument = gql`
    query DomainImportDeviceVariantList {
  deviceVariants(domainIdOrNone: null) {
    items {
      id
      name
      domain {
        id
      }
    }
  }
}
    `;

/**
 * __useDomainImportDeviceVariantListQuery__
 *
 * To run a query within a React component, call `useDomainImportDeviceVariantListQuery` and pass it any options that fit your needs.
 * When your component renders, `useDomainImportDeviceVariantListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDomainImportDeviceVariantListQuery({
 *   variables: {
 *   },
 * });
 */
export function useDomainImportDeviceVariantListQuery(baseOptions?: Apollo.QueryHookOptions<DomainImportDeviceVariantListQuery, DomainImportDeviceVariantListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DomainImportDeviceVariantListQuery, DomainImportDeviceVariantListQueryVariables>(DomainImportDeviceVariantListDocument, options);
      }
export function useDomainImportDeviceVariantListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DomainImportDeviceVariantListQuery, DomainImportDeviceVariantListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DomainImportDeviceVariantListQuery, DomainImportDeviceVariantListQueryVariables>(DomainImportDeviceVariantListDocument, options);
        }
export function useDomainImportDeviceVariantListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DomainImportDeviceVariantListQuery, DomainImportDeviceVariantListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DomainImportDeviceVariantListQuery, DomainImportDeviceVariantListQueryVariables>(DomainImportDeviceVariantListDocument, options);
        }
export type DomainImportDeviceVariantListQueryHookResult = ReturnType<typeof useDomainImportDeviceVariantListQuery>;
export type DomainImportDeviceVariantListLazyQueryHookResult = ReturnType<typeof useDomainImportDeviceVariantListLazyQuery>;
export type DomainImportDeviceVariantListSuspenseQueryHookResult = ReturnType<typeof useDomainImportDeviceVariantListSuspenseQuery>;
export type DomainImportDeviceVariantListQueryResult = Apollo.QueryResult<DomainImportDeviceVariantListQuery, DomainImportDeviceVariantListQueryVariables>;
export const AddDomainAdminsDocument = gql`
    mutation addDomainAdmins($domainId: Int!, $domainAdmins: [DomainAdminInput!]!) {
  addDomainAdmins(domainId: $domainId, domainAdmins: $domainAdmins) {
    errors {
      location
      type
      context
    }
  }
}
    `;
export type AddDomainAdminsMutationFn = Apollo.MutationFunction<AddDomainAdminsMutation, AddDomainAdminsMutationVariables>;

/**
 * __useAddDomainAdminsMutation__
 *
 * To run a mutation, you first call `useAddDomainAdminsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddDomainAdminsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addDomainAdminsMutation, { data, loading, error }] = useAddDomainAdminsMutation({
 *   variables: {
 *      domainId: // value for 'domainId'
 *      domainAdmins: // value for 'domainAdmins'
 *   },
 * });
 */
export function useAddDomainAdminsMutation(baseOptions?: Apollo.MutationHookOptions<AddDomainAdminsMutation, AddDomainAdminsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddDomainAdminsMutation, AddDomainAdminsMutationVariables>(AddDomainAdminsDocument, options);
      }
export type AddDomainAdminsMutationHookResult = ReturnType<typeof useAddDomainAdminsMutation>;
export type AddDomainAdminsMutationResult = Apollo.MutationResult<AddDomainAdminsMutation>;
export type AddDomainAdminsMutationOptions = Apollo.BaseMutationOptions<AddDomainAdminsMutation, AddDomainAdminsMutationVariables>;
export const SystemDeviceTypeSetsDocument = gql`
    query SystemDeviceTypeSets {
  deviceTypeSets {
    name
    devices
  }
}
    `;

/**
 * __useSystemDeviceTypeSetsQuery__
 *
 * To run a query within a React component, call `useSystemDeviceTypeSetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSystemDeviceTypeSetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSystemDeviceTypeSetsQuery({
 *   variables: {
 *   },
 * });
 */
export function useSystemDeviceTypeSetsQuery(baseOptions?: Apollo.QueryHookOptions<SystemDeviceTypeSetsQuery, SystemDeviceTypeSetsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SystemDeviceTypeSetsQuery, SystemDeviceTypeSetsQueryVariables>(SystemDeviceTypeSetsDocument, options);
      }
export function useSystemDeviceTypeSetsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SystemDeviceTypeSetsQuery, SystemDeviceTypeSetsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SystemDeviceTypeSetsQuery, SystemDeviceTypeSetsQueryVariables>(SystemDeviceTypeSetsDocument, options);
        }
export function useSystemDeviceTypeSetsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SystemDeviceTypeSetsQuery, SystemDeviceTypeSetsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SystemDeviceTypeSetsQuery, SystemDeviceTypeSetsQueryVariables>(SystemDeviceTypeSetsDocument, options);
        }
export type SystemDeviceTypeSetsQueryHookResult = ReturnType<typeof useSystemDeviceTypeSetsQuery>;
export type SystemDeviceTypeSetsLazyQueryHookResult = ReturnType<typeof useSystemDeviceTypeSetsLazyQuery>;
export type SystemDeviceTypeSetsSuspenseQueryHookResult = ReturnType<typeof useSystemDeviceTypeSetsSuspenseQuery>;
export type SystemDeviceTypeSetsQueryResult = Apollo.QueryResult<SystemDeviceTypeSetsQuery, SystemDeviceTypeSetsQueryVariables>;